import React, { useEffect, useState } from 'react';
import Modal from 'component/hoc/modal/Modal';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Input from 'component/atom/forms/input/input/Input';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import styles from './RestrictAccess.module.scss';
import { useFetch } from 'hooks/useFetch';
import { scriptEndpoints } from 'hooks/endpoints';
import { usePost } from 'hooks/usePost';
import Loader from 'component/atom/loader/Loader';
const Form = ({ formik, isLoading, urls, setUrls, setTypedUrl }) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      formik.handleSubmit();
    }
  };

  const handleRemove = (index) => {
    setUrls(urls.filter((_, i) => i !== index));
  };

  const handleChange = (e) => {
    formik.setFieldValue('url', e.target.value);
    setTypedUrl(e.target.value);
  };
  return (
    <form
      autoComplete='off'
      onSubmit={formik.handleSubmit}
      className={styles.formCont}
    >
      <Input
        label='Add Url'
        placeholder='Enter Url'
        name='url'
        value={formik.values.url}
        onChange={(value) => handleChange(value)}
        onBlur={formik.handleBlur}
        error={formik.errors.url}
        touched={formik.touched.url}
        onKeyDown={handleKeyDown}
      />
      <div className={styles['cont']}>
        <p>Website</p>
        {isLoading ? (
          <Loader isComponent />
        ) : urls?.length > 0 ? (
          urls?.map((url, index) => (
            <div key={index} className={styles['single-web']}>
              <div className={styles['attachment']}>
                <SvgWithBranding type='websiteLink' className={styles.icon} />
                <p>{url}</p>
              </div>
              <SvgWithBranding
                type='closeSvg'
                className={styles.icon}
                color='#C81111'
                onClick={() => handleRemove(index)}
              />
            </div>
          ))
        ) : (
          <p className={styles.empty}>No data</p>
        )}
      </div>
    </form>
  );
};

const RestrictAccess = ({ isOpen, onClose, setRefetch, selectedItem }) => {
  const [urls, setUrls] = useState([]);
  const [typedUrl, setTypedUrl] = useState('');
  const {
    data: restrictedURL,
    refetch: refetchURL,
    isLoading,
  } = useFetch(
    ['restrictedUrlByBot', selectedItem?.botId],
    scriptEndpoints.getRestrictedUrl(selectedItem?.botId),
    {
      enabled: !!selectedItem?.botId,
    }
  );
  const { mutate: AddURL, isPending } = usePost({
    onSuccessToast: 'Updated Successfully',
    toastType: 'update',
  });
  const validationSchema = Yup.object({
    url: Yup.string().url('Invalid URL format'),
  });

  useEffect(() => {
    setUrls(restrictedURL?.data);
  }, [restrictedURL]);

  const handleUpdate = () => {
    const trimmed = formik.values.url?.trim();
    let newUrls = [...urls];

    if (trimmed && !urls.includes(trimmed)) {
      newUrls.push(trimmed);
    }

    AddURL(
      {
        url: scriptEndpoints.updateRestrictedUrl(),
        method: 'Put',
        data: {
          botId: selectedItem?.botId,
          url: newUrls,
        },
      },
      {
        onSuccess: () => {
          onClose();
          setRefetch((prev) => !prev);
        },
      }
    );
  };

  const formik = useFormik({
    initialValues: {
      url: '',
    },
    validationSchema,
    onSubmit: (values, { resetForm }) => {
      setUrls((prev) => [...prev, values.url]);
      formik.resetForm();
    },
    enableReinitialize: true,
  });

  useEffect(() => {
    if (!isOpen) {
      formik.resetForm();
    }
  }, [isOpen]);

  return (
    <div>
      <Modal
        title='Restrict Access'
        isOpen={isOpen}
        onClose={onClose}
        modalContent={{
          component: (
            <Form
              formik={formik}
              isLoading={isLoading}
              handleUpdate={handleUpdate}
              urls={urls}
              setUrls={setUrls}
              setTypedUrl={setTypedUrl}
            />
          ),
        }}
        onSubmit={handleUpdate}
        buttonType='submit'
        onSubmitstyles={{
          onSubmit: {
            label: 'Update',
            type: 'save',
            opicBAckground: true,
          },
        }}
        isLoading={isPending}
      />
    </div>
  );
};

export default RestrictAccess;
